import _ from "lodash";
import * as z from "../../framework";
import { buildDataBindSyntax } from "../components/buildDataBindSyntax";
import { searchDebounceWait } from "../core/core";
import * as divisionRegion from "../core/division.region";
import { ll } from "../core/ll";
import { emptyFn, isFunction } from "../core/util";
import { buildODataKendoParams } from "../data/buildODataKendoParams";
import { dataSource } from "../data/dataSource";
import { schemas } from "../data/schemas";
import { searchTypes } from "../data/searchTypes";

var regexEscape = function (str) {
    return str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
};

var replaceAllBold = function (str, search, replace) {
    return replace
        ? str.replace(new RegExp(`(${search})`, "ig"), "<b>$&</b>")
        : str;
};

export function autoComplete(options) {
    /*
    * autoComplete
    * Turn an input into an autocomplete
    *
    * All Kendo UI AutoComplete options are accepted
    *
    * Additional options
    * Id - ID of the autocomplete input created
    * width - width of the list drop down
    * templateJSON - JSON that will build a header template and list item template
    *
    *
    * Other Options used in conjuction
    * url or entityTyoe
    * ----pass these in to auto build a datasource
    * sort - default sort for the auto generated ds
    * filter - default filter for the auto generated ds
    * select - default select for the auto generated ds
    * expand - default expand for the auto generated ds
    *
    *
    * Defaults:
    * dataTextField = "Data"
    */
    options = options || {};

    options.animation = false;

    if (options.zScreen && options.zScreen.id) {
        options.id = `${options.zScreen.id}_${options.id}`;
        options.iconId = `${options.zScreen.id}_${options.iconId}`;
    }

    var clickedEnterTabOrder = false;
    if (options.runOnEnterAndTab) {
        $(`#${options.id}`).tie("keydown", function (ev) {
            var numSearch = $(this),
                searchValue = $.trim(numSearch.val());

            if ((ev.keyCode == 13 || (ev.keyCode == 9 && !ev.shiftKey)) && searchValue) {
                options.runOnEnterAndTab({
                    searchValue: searchValue,
                    enterKey: ev.keyCode == 13,
                    tabKey: ev.keyCode == 9
                });

                if (options.clearIfInvalid) {
                    numSearch.val("");
                }

                kendoAutoComplete.close();
                $.wait(1000).then(function () {
                    kendoAutoComplete.close();
                });
                clickedEnterTabOrder = true;
                ev.preventDefault();
                ev.stopPropagation();
                ev.stopImmediatePropagation();
            }
        });

        if (options.runOnBlur) {
            $(`#${options.id}`).tie("blur", function (ev) {
                var numSearch = $(this),
                    searchValue = $.trim(numSearch.val()),
                    selectedDataItem = ($(this).data("kendoAutoComplete") as any).selectedDataItem;

                if (!(selectedDataItem && selectedDataItem.Id)
                    && ((ev.keyCode == 9 && !ev.shiftKey) || ev.keyCode == null)
                    && searchValue
                ) {
                    options.runOnEnterAndTab({ searchValue: searchValue });

                    if (options.clearIfInvalid) {
                        numSearch.val("");
                    }

                    clickedEnterTabOrder = true;
                    ev.preventDefault();
                    ev.stopPropagation();
                    ev.stopImmediatePropagation();
                }
            });
        }
    }

    options.suggest = false;
    options.clearIfInvalid = options.clearIfInvalid == undefined || options.clearIfInvalid;

    var searchType: any = {};

    if ($(`#${options.id}`).data("kendoAutoComplete")) {
        return $(`#${options.id}`).data("kendoAutoComplete");
    }

    var displayFields: any[] = options.displayFields || [];

    if (options.entityType || options.entityTypeSchema) {
        var schema = options.entityTypeSchema
            ? options.entityTypeSchema
            : schemas[options.entityType];

        if (schema) {
            var keys = Object.keys(schema.Properties);
            if (displayFields.length <= 0) {
                displayFields = $.grep(keys, function (c) { return schema.Properties[c].Display; });
            }

            var secondaryField = _.find(displayFields, function (c) { return schema.Properties[c] && schema.Properties[c].Display == "secondary"; }),
                primaryField = _.find(displayFields, function (c) { return schema.Properties[c] && schema.Properties[c].Display == "primary"; });

            options.dataTextField = options.dataTextField || secondaryField || primaryField;
            options.nullableTextField = (schema.Properties[primaryField] && !schema.Properties[primaryField].Required)
                ? primaryField
                : null;
            options.bindNumberValue = options.bindNumberValue || buildDataBindSyntax(primaryField, "text");
            options.sortExpression = options.sortExpression || primaryField;
        }

        searchType = searchTypes.generate(options.entityType || options.entityTypeSchema);
    }

    options.filterExpression = divisionRegion.createAutocompleteFilterExpression(options, searchType) || options.filterExpression;

    if (!options.dataSource && (options.url || options.entityType)) {
        if (!options.url && options.entityType) {
            options.url = "" + options.entityType;
        } else if (!options.entityType) {
            var index = options.url.lastIndexOf("/");
            options.entityType = options.url.substring(index + 1);
        }

        var condition = $.map(displayFields, function (c) { return { value: c }; });

        const headers = {};
        if (options.companyGuid) {
            headers["Company-GUID"] = options.companyGuid;
        }

        var ds = dataSource({
            transport: {
                read: {
                    url: (options.urlPrefix || "") + options.url,
                    contentType: "application/json",
                    beforeSend: options.beforeSend,
                    headers
                },
                parameterMap: function (data) {
                    var sort = options.sortExpression;
                    var filter = options.filterExpression;
                    var select = options.selectExpression;
                    var expand = options.expandExpression;

                    if (isFunction(sort)) {
                        sort = sort();
                    }

                    if (isFunction(filter)) {
                        filter = filter();
                    }

                    if (isFunction(select)) {
                        select = select();
                    }

                    if (isFunction(expand)) {
                        expand = expand();
                    }

                    return buildODataKendoParams({
                        data: data,
                        sortExpression: sort,
                        filterExpression: filter,
                        selectExpression: select,
                        expandExpression: expand,
                        autoCompleteConditional: options.autoCompleteConditional || condition,
                        disableAutoCompleteConditional: options.disableAutoCompleteConditional,
                        dataTextField: options.nullableTextField
                    });
                }
            }
        });
        options.dataSource = ds;
    }

    if (options.entityType
        && !options.templateJSON
        && !options.template
        && !options.headerTemplate
    ) {
        let columns = $.map(displayFields, function (searchOption) {
            searchOption = typeof(searchOption) == "string"
                ? searchOption
                : searchOption.field;
            let label = searchOption;

            if (searchType) {
                if (searchType.screenEntityType) {
                    label = `${searchType.screenEntityType}.${label}`;
                } else if (searchType.columnRenames[searchOption]) {
                    label = searchType.columnRenames[searchOption];
                }
            }

            return {
                width: 200,
                data: `data.${searchOption} || '---'`,
                headerLabel: ll(label),
                columnClasses: "data-column"
            };
        });

        if (options.extraTemplateColumns) {
            $.each(options.extraTemplateColumns, function (i, column) {
                if (column.headerLabelName) {
                    column.headerLabel = ll(column.headerLabelName);
                }

                columns.push(column);
            });
        }

        options.templateJSON = {
            columns: columns
        };
    }

    if (options.templateJSON && (options.template || options.headerTemplate)) {
        throw new Error("Error initializing autocomplete. Either pass in a templateJSON OR (template AND headerTemplate)");
    }

    if (options.templateJSON) {
        var templates = buildListTemplates(options.templateJSON);

        if (!options.templateJSON.disableHeader) {
            options.headerTemplate = templates.headerTemplate;
        }

        options.template = templates.template;
        options.width = templates.width + 25;
    }

    options.height = options.height || 300;
    options.searchSelector = options.searchSelector || ".data-column";
    var db = options.dataBound || emptyFn;

    options.dataBound = function (e) {
        var ul = this.ul,
            element = this.element,
            data = ul.find(options.searchSelector),
            searchValue = element.val().trim();

        $.each(data, function (i, value) {
            var text = $(value).text();
            if (options.delimiter) {
                searchValue.split(options.delimiter).every(function (v) {
                    var temp = replaceAllBold(text, regexEscape(v), true);
                    if (temp != text) {
                        $(value).html(temp);
                    }

                    return temp == text;
                });
            } else {
                $(value).html(replaceAllBold(text, regexEscape(searchValue), true));
            }
        });

        element.data("kendoAutoComplete").list.find("ul").height(options.height - 26);

        db.apply(this, [e]);
    };

    delete options.zScreen;

    if (options.containsSearch) {
        options.filter = "contains";
    }

    options.delay = options.delay || searchDebounceWait;

    var kendoAutoComplete = $(`#${options.id}`).kendoAutoComplete(options).data("kendoAutoComplete");

    if (options.runOnEnterAndTab) {
        kendoAutoComplete.bind("open", function () {
            if (clickedEnterTabOrder) {
                this.close();
            }
            clickedEnterTabOrder = false;
        });
    }

    if (options.width) {
        kendoAutoComplete && kendoAutoComplete.list.width(options.width);
    }

    options.focusSearch = options.focusSearch == undefined
        ? true
        : options.focusSearch;

    if (options.focusSearch || options.sort) {
        var open = false;
        kendoAutoComplete.bind("open", function () {
            open = true;
        });

        kendoAutoComplete.bind("close", function () {
            open = false;
        });

        // The mousedown, mouseup, focus, and click are all necessary for the autocompletes to work when
        // tabbing into them or clicking or some combination of both cases. The specific case was Bug 18135
        $(`#${options.id}`).tie("mousedown", function () {
            $(this).data("mouseDown", true);
        });

        $(`#${options.id}`).tie("mouseup", function () {
            $(this).removeData("mouseDown");
        });

        $(`#${options.id}`).tie("focus", function () {
            if (!$(this).data("mouseDown")) {
                $(this).trigger("click");
            }
        });

        $(`#${options.id}`).tie("click", function () {
            if ((this == document.activeElement)
                && !open
                && !($(this).attr("readonly") == "readonly")
            ) {
                kendoAutoComplete.search(" ");
            }
        });
    }

    $(`#${options.id}`).data("kendoAutoComplete").bind("select", function (e) {
        var dataItem = this.dataItem(e.item.index());
        if (dataItem) {
            if (options.displayField) {
                $(`#${options.id}`).val(dataItem[options.displayField]);
            }

            if (options.zSelect && !options.disableZSelect) {
                options.zSelect(dataItem);
                e.preventDefault();
            }
        }

        this.selectedDataItem = dataItem;
    });

    $(`#${options.id}`).bind("change", function () {
        if (!this.value && options.zSelect && !options.disableZSelect) {
            options.zSelect({ Id: null });
            this.selectedDataItem = null;
        }
    });

    if (options.zSelect) {
        $(`#${options.id}`).data("zSelect", options.zSelect);
    }

    if (options.clearIfInvalid) {
        var isValid;

        kendoAutoComplete.bind("open", function () {
            isValid = false;
        });

        kendoAutoComplete.bind("select", function () {
            isValid = true;
        });

        kendoAutoComplete.bind("blur", function () {
            if (!isValid) {
                this.value("");
                $(`#${this.id}`).parents(".pane-field").find(".pane-field-number").text("");
            }
        });

        $(`#${options.id}`).bind("change", function () {
            if (this.val) {
                if (!isValid) {
                    this.val("");

                    if (this.parents && $.isFunction(this.parents)) {
                        this.parents(".pane-field").find(".pane-field-number").text("");
                    }
                }
            }

            if (this.value) {
                if (!isValid) {
                    this.value = "";
                }
            }
        });
    }

    kendoAutoComplete.bind("change", function () {
        if (!this.value()) {
            $(this.element).parents(".pane-field").find(".pane-field-number").text("");
        }
    });

    $(`#${options.id}`).tie("keyup", function () {
        if (!$(`#${options.id}`).val()) {
            $(`#${options.id}`).parents(".pane-field").find(".pane-field-number").text("");
        }
    });

    $(`#${options.id}`).tie("blur", function () {
        if (!$(`#${options.id}`).val()) {
            $(`#${options.id}`).parents(".pane-field").find(".pane-field-number").text("");
        }
    });

    if (options.blur) {
        $(`#${options.id}`).tie("blur", options.blur);
    }

    return kendoAutoComplete;
}

export function buildListTemplates(options) {
    var result = {
        headerTemplate: `<div class="k-dropdown-header ${(options.headerClasses || "")}">`,
        template: `<div class="k-state-default k-dropdown-option ${(options.templateClasses || "")}">`,
        width: 0
    };

    var widthAccurate = true;
    options = options || {};

    if (options.disableHeader) {
        delete result.headerTemplate;
    }

    if (!$.isArray(options.columns)) {
        options.columns = [options.columns];
    }

    $.each(options.columns, function (index: any, column) {
        var width = column.width
            ? `style="width: ${column.width}px"`
            : "",
            data = column.data
                ? `#=${column.data} #`
                : "",
            columnClasses = column.columnClasses || "";

        if (column.dataTemplate) {
            data = column.dataTemplate;
        }

        if (column.width) {
            result.width += column.width + 5; // 5 for padding

            if (index == 0) {
                result.width += 2; // 2 for margin on first column
            }
        } else {
            widthAccurate = false;
        }
        if (!options.disableHeader) {
            var columnHeaderClasses = column.columnHeaderClasses || "";
            if (column.labelName) {
                column.headerLabel = ll(column.labelName);
            }

            column.headerLabel = column.headerLabel.replaceAll("#", "\\#");
            result.headerTemplate += '<span class="k-widget k-header identifier-dropdown {0}" {1}>{2}</span>'.format(columnHeaderClasses, width, column.headerLabel);
        }
        result.template += '<span class="identifier-dropdown {0}" {1}>{2}</span>'.format(columnClasses, width, data);
    });

    // close up the container div
    if (!options.disableHeader) {
        result.headerTemplate += "</div>";
    }

    result.template += "</div>";

    if (!widthAccurate) {
        delete result.width;
    }

    return result;
}
